import { render, staticRenderFns } from "./handleCom.vue?vue&type=template&id=9f0d380c&scoped=true&"
import script from "./handleCom.vue?vue&type=script&lang=js&"
export * from "./handleCom.vue?vue&type=script&lang=js&"
import style0 from "./handleCom.vue?vue&type=style&index=0&id=9f0d380c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0d380c",
  null
  
)

component.options.__file = "handleCom.vue"
export default component.exports